import { NavLink, useLocation } from 'react-router-dom';

/** Barra de abas (10.2): kanji Shippori 22 px (800 ativa, 600 demais), rótulo 11 px, ponto vermelhão. */
const TABS = [
  { kanji: '今', label: 'Hoje', to: '/', match: (p: string) => p === '/' || ['/agua', '/historico', '/lembretes', '/perfil'].some((x) => p.startsWith(x)) },
  { kanji: '食', label: 'Comida', to: '/comida', match: (p: string) => p.startsWith('/comida') },
  { kanji: '練', label: 'Treino', to: '/treino', match: (p: string) => p.startsWith('/treino') },
  { kanji: '学', label: 'Estudo', to: '/estudo', match: (p: string) => p.startsWith('/estudo') },
  { kanji: '進', label: 'Progresso', to: '/progresso', match: (p: string) => p.startsWith('/progresso') },
];

export function TabBar() {
  const { pathname } = useLocation();
  return (
    <nav
      aria-label="Navegação principal"
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 20,
        marginTop: 'auto',
        display: 'flex',
        background: 'var(--card)',
        borderTop: '1px solid var(--line)',
        padding: '6px 4px calc(18px + env(safe-area-inset-bottom))',
      }}
    >
      {TABS.map((t) => {
        const active = t.match(pathname);
        return (
          <NavLink
            key={t.to}
            to={t.to}
            aria-current={active ? 'page' : undefined}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
              padding: '6px 0',
              textDecoration: 'none',
              color: active ? 'var(--ink)' : 'var(--muted)',
              minHeight: 44,
            }}
          >
            <span
              lang="ja"
              aria-hidden="true"
              style={{ fontFamily: 'var(--font-serif)', fontSize: 22, lineHeight: 1.1, fontWeight: active ? 800 : 600 }}
            >
              {t.kanji}
            </span>
            <span style={{ fontSize: 11, fontWeight: 700 }}>{t.label}</span>
            <span style={{ width: 5, height: 5, borderRadius: 999, background: active ? 'var(--shu)' : 'transparent' }} />
          </NavLink>
        );
      })}
    </nav>
  );
}
